import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import UploadReceipt from './UploadReceiptStatutory'
import React from 'react'
import { useQuery } from 'react-query'
import { getStatutoryReceipt } from 'services/api/modules/payroll/payroll-history'
import Bugsnag from '@bugsnag/js'

const StatutoryTable = ({
  total_amount,
  downloadEpf,
  downloadSocso,
  downloadEis,
  downloadMaybankEis,
  downloadMaybankEpf,
  downloadMaybankSocso,
  downloadMaybankTax,
  downloadLhdn,
  downloadHrdf,
  time_id,
}) => {
  const { total_eis, total_epf, total_socso, total_mtd_payment, total_hrdf_payment } = total_amount

  const { data: statutoryReceipt } = useQuery(
    ['retrieveStatutoryReceipt', time_id],
    async () => {
      const { data } = await getStatutoryReceipt(time_id)
      return data?.data
    },
    {
      onError: (error) => {
        if (error.status !== 404) {
          if (error.status === 422) {
            console.log(error)
          } else {
            Bugsnag.notify(error.data)
          }
        }
      },
    }
  )

  const DownloadStatutoryForm = ({ onClick, title }) => {
    return (
      <Typography
        onClick={onClick}
        sx={{
          cursor: 'pointer',
          padding: '16px',
          color:
            total_amount?.hrdf_status === 0 && title === 'HRDF Report'
              ? 'light-gray-text-2.main'
              : 'alternate.main',
          textDecoration: 'underline',
          textDecorationColor:
            total_amount?.hrdf_status === 0 && title === 'HRDF Report'
              ? 'light-gray-text-2.main'
              : 'alternate.main',
        }}
      >
        {title}
      </Typography>
    )
  }

  return (
    <TableContainer
      sx={{
        backgroundColor: 'white.main',
        border: 1,
        borderBottom: 0,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
        boxShadow: 'none',
        '& th.MuiTableCell-root': {
          padding: '20px 16px',
        },
        '& td.MuiTableCell-root': {
          padding: '0px',
        },
      }}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="subtitle2" color="light-gray-text.main">
                Statutory body
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2" color="light-gray-text.main">
                Total payout
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2" color="light-gray-text.main">
                Download
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2" color="light-gray-text.main" textAlign="center">
                Upload file
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[
            {
              name: 'EPF',
            },
            {
              name: 'SOCSO',
            },
            {
              name: 'EIS',
            },
            {
              name: 'LHDN',
            },
            {
              name: 'HRDF',
            },
          ]?.map((list, index) => (
            <TableRow key={index}>
              <TableCell>
                <Typography
                  color={
                    list.name === 'HRDF' &&
                    total_amount?.hrdf_status === 0 &&
                    'light-gray-text-2.main'
                  }
                  sx={{ padding: '25px 16px' }}
                >
                  {list.name}
                </Typography>
              </TableCell>
              <TableCell>
                {list.name === 'EPF' ? (
                  <Typography sx={{ padding: '25px 16px' }}>{`RM ${total_epf}`}</Typography>
                ) : list.name === 'SOCSO' ? (
                  <Typography sx={{ padding: '25px 16px' }}>{`RM ${total_socso}`}</Typography>
                ) : list.name === 'EIS' ? (
                  <Typography sx={{ padding: '25px 16px' }}>{`RM ${total_eis}`}</Typography>
                ) : list.name === 'LHDN' ? (
                  <Typography sx={{ padding: '25px 16px' }}>{`RM ${total_mtd_payment}`}</Typography>
                ) : (
                  list.name === 'HRDF' && (
                    <Typography
                      color={total_amount?.hrdf_status === 0 && 'light-gray-text-2.main'}
                      sx={{ padding: '25px 16px' }}
                    >{`RM ${total_hrdf_payment}`}</Typography>
                  )
                )}
              </TableCell>
              <TableCell>
                {list.name === 'EPF' ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                    <DownloadStatutoryForm onClick={downloadEpf} title="Form A" />
                    {downloadMaybankEpf && (
                      <DownloadStatutoryForm onClick={downloadMaybankEpf} title="Maybank EPF File" />
                    )}
                  </Box>
                ) : list.name === 'SOCSO' ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                    <DownloadStatutoryForm onClick={downloadSocso} title="Borang 8A" />
                    {downloadMaybankSocso && (
                      <DownloadStatutoryForm onClick={downloadMaybankSocso} title="Maybank SOCSO File" />
                    )}
                  </Box>
                ) : list.name === 'EIS' ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                    <DownloadStatutoryForm onClick={downloadEis} title="Lampiran 1" />
                    {downloadMaybankEis && (
                      <DownloadStatutoryForm onClick={downloadMaybankEis} title="Maybank EIS File" />
                    )}
                  </Box>
                ) : list.name === 'LHDN' ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                    <DownloadStatutoryForm onClick={downloadLhdn} title="CP39" />
                    {downloadMaybankTax && (
                      <DownloadStatutoryForm onClick={downloadMaybankTax} title="Maybank TAX File" />
                    )}
                  </Box>
                ) : (
                  list.name === 'HRDF' && (
                    <DownloadStatutoryForm
                      onClick={total_amount?.hrdf_status === 1 ? downloadHrdf : null}
                      title="HRDF Report"
                    />
                  )
                )}
              </TableCell>
              <TableCell
                textAlign="right"
                display="flex"
                justifyContent="flex-end"
                sx={{ width: '185px' }}
              >
                {list.name === 'EPF' ? (
                  <UploadReceipt
                    receiptName="epf_receipts"
                    data={statutoryReceipt?.epf}
                    time_id={time_id}
                  />
                ) : list.name === 'SOCSO' ? (
                  <UploadReceipt
                    receiptName="socso_receipts"
                    data={statutoryReceipt?.socso}
                    time_id={time_id}
                  />
                ) : list.name === 'EIS' ? (
                  <UploadReceipt
                    receiptName="eis_receipts"
                    data={statutoryReceipt?.eis}
                    time_id={time_id}
                  />
                ) : list.name === 'LHDN' ? (
                  <UploadReceipt
                    receiptName="lhdn_receipts"
                    data={statutoryReceipt?.mtd}
                    time_id={time_id}
                  />
                ) : (
                  list.name === 'HRDF' && (
                    <UploadReceipt
                      receiptName="hrdf_receipts"
                      data={statutoryReceipt?.hrdf}
                      time_id={time_id}
                      hrdf_status={total_amount?.hrdf_status}
                    />
                  )
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default StatutoryTable
